import { useContext } from "react"
import UserDataContext from "../UserDataContext"


const useLangCodes = () => {
    const { languages, languageCodes, languageCodesForTrans } = useContext(UserDataContext)
    return [languages, languageCodes, languageCodesForTrans]
}
export default useLangCodes